import axiosInstanceService, { microServices } from 'network/apis/index'
import { METHOD_TYPES } from 'utils/constants/index'

export const placeBetPlinkoGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'plinko-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const demoPlaceBetPlinkoGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'plinko-game/demo-place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyBetsPlinkoService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'plinko-game/my-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const verifyProvablePlinkoService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'plinko-game/check-provable-fair', data, {
    server: microServices.SERVICE_URL_1
  })
}
